export const TEST_IDS = {
  APP_TILE: 'app-tile',
  ATLASSIAN_APP_TILE_COMPACT: 'atlassian-app-tile-compact',
  CERTIFICATION_BADGE: 'app-tile__certification-badge',
  RATINGS: 'app-tile__ratings',
  TILE_BADGE: 'app-tile__tile-badge',
  APP_TILE_SKELETON: 'app-tile-skeleton',
  APP_TILE_SKELETON_COMPACT: 'app-tile-skeleton-compact'
};